import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { useCompanyScopeLandingsContext } from "../contexts";

export const usePrefixedRoutingLandings = () => {
  const navigate = useNavigate();
  const { companyId: currentCompanyId, isDynamicLandingPage } =
    useCompanyScopeLandingsContext();
  const prefix: string = useMemo(() => {
    const endPrefix = isDynamicLandingPage ? "/landing" : "";
    return `/c/${currentCompanyId}${endPrefix}`;
  }, [currentCompanyId, isDynamicLandingPage]);

  const addLandingPrefix = useCallback(
    (routeRaw: string): string => {
      return `${prefix}${routeRaw}`;
    },
    [prefix],
  );

  const navigateLandingPrefixed = useCallback(
    (url: string) => {
      navigate(addLandingPrefix(url));
    },
    [addLandingPrefix, navigate],
  );
  return { prefix, addLandingPrefix, navigateLandingPrefixed };
};
